<template>
  <Breadcrumbs />
  <div class="offers-page container mb-4">
    <OfferCategoriesList class="categories-list" />
    <div class="offers">
      <DynamicContent
        id="offer-overview-content"
        class="dynamic-content offers-content"
        :style="{ padding: 0 }"
        :html="content?.introductionBlock"
      ></DynamicContent>

      <OfferSearchInput :search-query="searchQuery" class="mb-1" />
      <OffersGrid
        :pagination="{ limit: 24, offset: 0 }"
        :input="{
          search: debouncedSearchQuery,
        }"
        :infinite-loading="false"
        :show-load-more="true"
        class="offers-grid small-tiles"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouteQuery } from "@vueuse/router";
import { useWebsitePageQuery } from "~/graphql/generated";
false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    "nl-NL": "/aanbiedingen",
    fr: "/offres",
    nl: "/aanbiedingen",
  },
});

const searchQuery = useRouteQuery("search-offers", "", { transform: String });
const debouncedSearchQuery = useDebounce(searchQuery, 500);

// We don't use the `aanbiedingen?offer-category` route anymore, thus we redirect.
// This isn't in a `onMounted` hook because for some reason that messed with the history.
const offerCategory = useRouteQuery("offer-category", "", {
  transform: String,
});
if (offerCategory.value) {
  const localePath = useLocalePath();
  const path = localePath({
    name: "offers-slug",
    params: { slug: offerCategory.value },
  });
  navigateTo({ path: path }, { redirectCode: 301 });
}

// Set the (optional) page content blocks
const path = useRoute().path;

const { websitePagePath } = useWebsitePagePath(path);

const page = await useWebsitePageQuery({
  variables: websitePagePath,
});

const content = useDynamicContent(page.data);
</script>

<style lang="scss" scoped>
.offers-page {
  display: flex;
  gap: 1.5rem;

  @include for-small-screen {
    flex-direction: column;
  }

  .categories-list {
    min-width: 14rem;
    width: 20%;

    @include for-small-screen {
      width: 100%;
    }
  }

  .offers {
    flex: 1;
  }

  .offers-grid {
    padding: 0;
  }
}
</style>
